import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { TaskflowTemplateModel } from 'models/generated/Entities.GormCrm.TaskflowTemplate';
import { TaskflowTemplateTagModel } from 'models/generated/Entities.GormCrm.TaskflowTemplateTag';
import { TaskTemplateTagModel } from 'models/generated/Entities.GormCrm.TaskTemplateTag';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class TaskflowTemplateService { 
	private baseUrl = `${environment.gatewayUrl}/api`;

	constructor(private readonly http: HttpClient) {
	}

	getTemplate(id: string): Promise<TaskflowTemplateModel> {
		return firstValueFrom(this.http.get<TaskflowTemplateModel>(`${this.baseUrl}/taskflow-templates/${id}`));
	}

	getTemplates(): Promise<TaskflowTemplateModel[]> {
		return firstValueFrom(this.http.get<TaskflowTemplateModel[]>(`${this.baseUrl}/taskflow-templates/`));
	}

	getAllTaskflowTemplateTags(): Promise<TaskflowTemplateTagModel[]> {
		return firstValueFrom(this.http.get<TaskflowTemplateTagModel[]>(`${this.baseUrl}/taskflow-templates/tags`));
	}

	getAllTaskTemplateTags(): Promise<TaskTemplateTagModel[]> {
		return firstValueFrom(this.http.get<TaskTemplateTagModel[]>(`${this.baseUrl}/task-action-templates/tags`));
	}

	createTemplate(taskflowTemplate: TaskflowTemplateModel): Promise<TaskflowTemplateModel> {
		return firstValueFrom(this.http.post<TaskflowTemplateModel>(`${this.baseUrl}/taskflow-templates`, taskflowTemplate));
	}

	updateTemplate(taskflowTemplate: TaskflowTemplateModel): Promise<TaskflowTemplateModel> {
		return firstValueFrom(this.http.put<TaskflowTemplateModel>(`${this.baseUrl}/taskflow-templates`, taskflowTemplate));
	}

	deleteTemplate(taskflowTemplateId: string): Promise<void> {
		return firstValueFrom(this.http.delete(`${this.baseUrl}/taskflow-templates/${taskflowTemplateId}`)).then(() => {
			return;
		});
	}
}